import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const OfferSection = () => {
  const { t } = useTranslation();
  const o = t('home.offer', { returnObjects: true });

  return (
    <section data-testid="the-offer" className="py-16 md:py-24">
      <div className="container-custom max-w-3xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center">
          <div className="inline-flex items-center px-5 py-2 rounded-full border border-[#c8ff00]/40 mb-8">
            <span className="text-[#c8ff00] text-sm font-bold uppercase tracking-wider">{o.badge}</span>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-['Syne'] text-white mb-4">{o.title}</h2>
          <p className="text-[#c8ff00] text-5xl md:text-7xl font-bold font-['Syne'] mb-3">{o.price}</p>
          <p className="text-gray-400 text-base mb-2">{o.terms}<span className="text-white/70">{o.realValue}</span></p>
        </motion.div>

        <div className="border-t border-white/10 my-10" />

        <p className="text-gray-500 text-xs uppercase tracking-[0.2em] font-bold mb-6">{o.whatsIncluded}</p>
        <div className="space-y-0">
          {o.items.map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }} data-testid={`offer-item-${i}`} className="flex items-start justify-between gap-4 py-5 border-b border-white/5">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 rounded-full bg-[#c8ff00] mt-2 flex-shrink-0" />
                <div>
                  <h4 className="text-white font-bold text-base">{item.title}</h4>
                  <p className="text-gray-500 text-sm mt-0.5">{item.desc}</p>
                </div>
              </div>
              <span className="text-sm font-bold text-[#c8ff00]/80 border border-[#c8ff00]/20 bg-[#c8ff00]/5 px-3 py-1 rounded-md whitespace-nowrap flex-shrink-0">{item.value} value</span>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-8 flex items-center justify-between p-4 rounded-xl border border-[#c8ff00]/30 bg-[#c8ff00]/5">
          <span className="text-white font-bold">{o.totalValue}</span>
          <span className="text-[#c8ff00] font-bold">{o.totalValueAmount} <span className="text-white/40 mx-2">&rarr;</span> {o.youPay}</span>
        </motion.div>

        <div className="text-center mt-10">
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="offer-cta">
            <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-10 py-4 bg-[#c8ff00] text-black font-bold rounded-full text-lg hover:bg-[#d4ff33] transition-colors">
              {o.cta}
              <ArrowRight className="w-5 h-5" />
            </motion.span>
          </a>
          <p className="text-white/30 text-sm mt-3">{o.ctaSub}</p>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
